import React from 'react';
import { FadeIn } from './FadeIn';
const featured = [{
  id: 1,
  title: 'Menopausia y sexualidad.',
  subtitle: 'Una nueva etapa',
  description: 'Desmitificando los síntomas y abrazando la transformación con información clara y contención emocional.',
  originalPrice: '$45.000',
  price: '$19.000',
  color: 'bg-durazno',
  buyLink: 'https://habitandomicuerpo.shop/products/menopausia-y-sexualidad',
  coverImage: 'https://image2url.com/r2/default/files/1775024715984-612be3aa-ae12-479c-bc80-83d1c2104b60.png'
}, {
  id: 2,
  title: 'Vivir con obesidad',
  subtitle: 'Habitar sin culpa',
  description: 'Un recorrido compasivo para entender tu cuerpo fuera de los mandatos estéticos y médicos tradicionales.',
  originalPrice: '$45.000',
  price: '$19.000',
  color: 'bg-beige',
  buyLink: 'https://habitandomicuerpo.shop/products/vivir-con-obesidad',
  coverImage: 'https://image2url.com/r2/default/files/1775025609917-19642f06-07a7-4601-99e6-5beeee695c9e.png'
}, {
  id: 3,
  title: 'Habitar la depresión',
  subtitle: 'Luz en la sombra',
  description: 'Reflexiones y herramientas suaves para los días donde todo cuesta un poco más.',
  originalPrice: '$45.000',
  price: '$19.000',
  color: 'bg-lila',
  buyLink: 'https://habitandomicuerpo.shop/products/habitar-la-depresion',
  coverImage: 'https://image2url.com/r2/default/files/1775025308976-f3e55e28-0499-4071-a6b7-cd6662dc2c0d.png'
}];
export function FeaturedEbooks() {
  return <section className="py-24 md:py-32 bg-beige/50" data-id="element-76">
      <div className="max-w-7xl mx-auto px-6 md:px-12" data-id="element-77">
        <FadeIn className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-78">
          <div className="max-w-2xl" data-id="element-79">
            <h2 className="font-serif text-4xl md:text-5xl text-texto mb-4" data-id="element-80">
              Ebooks destacados
            </h2>
            <p className="font-sans text-lg text-textoSuave" data-id="element-81">
              Nuestras lecturas más elegidas por mujeres que buscan respuestas,
              calma y autoconocimiento.
            </p>
          </div>
          <a href="#ebooks" className="inline-flex font-sans font-medium text-texto border-b border-texto pb-1 hover:text-textoSuave hover:border-textoSuave transition-colors whitespace-nowrap" data-id="element-82">
            Ver colección completa
          </a>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 lg:gap-12" data-id="element-83">
          {featured.map((ebook, index) => <FadeIn key={ebook.id} delay={index * 0.1} className="group flex flex-col sm:flex-row bg-blanco rounded-3xl overflow-hidden shadow-soft hover:shadow-md transition-all duration-300" data-id="element-84">
              {/* Image/Color Block Placeholder */}
              <div className={`sm:w-2/5 h-48 sm:h-auto ${ebook.color} relative overflow-hidden flex items-center justify-center`} data-id="element-85">
                {ebook.coverImage ? <img src={ebook.coverImage} alt={`Portada de ${ebook.title}`} className="w-full h-full object-cover" data-id="element-86" /> : <>
                    <div className="absolute inset-0 opacity-30 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-blanco to-transparent" data-id="element-87"></div>
                    <h3 className="font-serif text-3xl text-texto text-center relative z-10 opacity-80 mix-blend-multiply p-6" data-id="element-88">
                      {ebook.title}
                    </h3>
                  </>}
              </div>

              {/* Content */}
              <div className="p-8 sm:w-3/5 flex flex-col justify-between" data-id="element-89">
                <div data-id="element-90">
                  <span className="font-sans text-xs font-bold tracking-widest text-textoSuave uppercase mb-2 block" data-id="element-91">
                    {ebook.subtitle}
                  </span>
                  <h3 className="font-serif text-2xl text-texto mb-3" data-id="element-92">
                    {ebook.title}
                  </h3>
                  <p className="font-sans text-textoSuave mb-6 text-sm leading-relaxed" data-id="element-93">
                    {ebook.description}
                  </p>
                </div>

                <div className="flex items-end justify-between mt-auto pt-4 border-t border-beige" data-id="element-94">
                  <div className="flex flex-col gap-1" data-id="element-95">
                    <span className="inline-block bg-rosa/80 text-texto text-[10px] font-bold uppercase tracking-wider px-2 py-0.5 rounded-full w-fit" data-id="element-96">
                      Oferta
                    </span>
                    <span className="font-sans text-sm text-textoSuave line-through" data-id="element-97">
                      Antes: {ebook.originalPrice}
                    </span>
                    <span className="font-sans font-bold text-texto text-xl" data-id="element-98">
                      Ahora: {ebook.price}
                    </span>
                  </div>
                  <a href={ebook.buyLink} target="_blank" rel="noopener noreferrer" className="px-4 py-2 rounded-full bg-texto text-crema text-sm font-medium hover:bg-texto/90 transition-colors shrink-0" data-id="element-99">
                    Comprar
                  </a>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}